import mongoose, { InferSchemaType } from 'mongoose';
import { Document } from 'mongoose';
import { EModelName } from './model-name';

export enum EActivityEvent {
  Login = "login",
  Logout = "logout",
  PodcastClicked = "podcast-clicked",
  PodcastPlayed = "podcast-played",
  PodcastPageViewed = "podcast-page-viewed",
  HomePageViewed = "home-page-viewed",
  SettingsPageViewed = "settings-page-viewed",
  CalendarPageViewed = "calendar-page-viewed",
  ActivityPageViewed = "activity-page-viewed",
  MeetingSummaryPageViewed = "meeting-summary-page-viewed",
  AdHocMeetingInviteSent = "ad-hoc-meeting-invite-sent",
  TodoPageViewed = "todo-page-viewed",
  BillingPageViewed = "billing-page-viewed",
  AssistantSetupPageViewed = "assistant-setup-page-viewed",
  PocastSpeedChanged = "podcast-speed-changed",
  MeetingPrepClicked = "meeting-prep-clicked",
  TranscriptOpened = "transcript-opened",
  PushNotificationClicked = "push-notification-clicked",
  CampainEmailClicked = "campain-email-clicked",
  CampainEmailOpened = "campain-email-opened",
  DemoModeActivated = "demo-mode-activated",
  AccountDeleted = "account-deleted",
  AccountDeactivated = "account-deactivated",
  ManageCreditClicked = "manage-credit-card-clicked",
  GmailConnected = "gmail-connected",
  CalendarConnected = "calendar-connected",
  SettingsButtonClicked = "settings-button-clicked",
  CalendarFilterClicked = "calendar-filter-clicked",
  ActivityLogClicked = "activity-log-clicked",
  PrivacyPolicyClicked = "privacy-policy-clicked",
  ActivityLogViewed = "activity-log-viewed",
  TodoClicked = "todo-clicked",
  General = "general",
}

const ActivitySchema = new mongoose.Schema({
  user: {
    type: mongoose.Schema.Types.ObjectId,
    required: true,
    ref: EModelName.USER,
  },
  event: { type: String },
  source: { type: String }, // id of the source
  data: { type: mongoose.Schema.Types.Mixed },
  date: { type: Date, default: Date.now() },
});

export type T_ActivityBase = InferSchemaType<typeof ActivitySchema>;

// Extend the type to provide proper typing for event
export interface T_Activity extends Omit<T_ActivityBase, 'date'> {
  date: Date;
}

export type T_ActivityDocument = T_Activity &
  Document & {
    _id: string;
  };

export { ActivitySchema };
